<div id="printGymMembershipInfo">
  <div class="modal-header">
    <h5 class="modal-title text-capitalize" id="exampleModalLabel">
      <i class="fas fa-id-card px-2"></i> {{'ClientVisitInfo' | translate}}
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="modal-body text-start col-lg-12" *ngIf="clientLastVisitInfo">
        <div class="formCard">
          <table class="table table-sm">
            <tr>
              <td>{{ 'ClientName' | translate }}</td>
              <td> {{ clientLastVisitInfo.ClientName }}</td>
            </tr>

            <tr>
              <td>{{ 'ClientMobile' | translate }}</td>
              <td> {{ clientLastVisitInfo.ClientMobile}}</td>
            </tr>

            <tr>
              <td>{{ 'BranchName' | translate }}</td>
              <td> {{ clientLastVisitInfo.BranchName}}</td>
            </tr>

            <tr>
              <td>{{ 'AddedByCashierName' | translate }}</td>
              <td> {{ clientLastVisitInfo.AddedByCashierName}}</td>
            </tr>

            <tr>
              <td>{{ 'VisitDate' | translate }}</td>
              <td> {{clientLastVisitInfo.VisitDate | date: 'yyyy-MM-dd hh:mm a'}}</td>
            </tr>

            <tr>
              <td>{{ 'VisitType' | translate }}</td>
              <td> {{ (clientLastVisitInfo.VisitType == visitType.Bill ?
                'ABill' : 'ABooking') | translate}}</td>
            </tr>

            <tr *ngIf="clientLastVisitInfo.VisitType == visitType.Bill ">
              <td>{{ 'BillCode' | translate }}</td>
              <td> {{ clientLastVisitInfo.BillCode}}</td>
            </tr>

            <tr *ngIf="clientLastVisitInfo.VisitType == visitType.Booking ">
              <td>{{ 'BookingNumber' | translate }}</td>
              <td> {{ clientLastVisitInfo.BookingNumber}}</td>
            </tr>

            <tr *ngIf="clientLastVisitInfo.VisitType == visitType.Booking ">
              <td>{{ 'BookingStatus' | translate }}</td>
              <td> {{ clientLastVisitInfo.BookingStatusText | translate}}</td>
            </tr>

            <tr>
              <td>{{ 'TotalPrice' | translate }}</td>
              <td>
                {{clientLastVisitInfo.TotalPrice.toFixed(sharedService.GetFractionRoundCount)
                }}</td>
            </tr>

          </table>
        </div>

        <div class="formCard" *ngIf="clientLastVisitInfo.Items &&
            clientLastVisitInfo.Items.length > 0">
          <br>
          <h5 class="modal-title text-capitalize" id="exampleModalLabel">
            <i class="fas fa-tasks px-2"></i>
            {{ (clientLastVisitInfo.VisitType == visitType.Bill ? 'BillItems' :'BookingItems') | translate}}
          </h5>
          <br>
          <div class="formCard">
            <div>
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th style="width: 5%;" class="text-center">{{ 'Index' | translate }}</th>
                    <th style="width: 20%;" class="text-center">{{ 'ItemName' | translate }}</th>
                    <th style="width: 20%;" class="text-center">{{ 'EmployeeName' | translate }}</th>
                    <th *ngIf="isContainsSecondEmployee(clientLastVisitInfo.Items)" style="width: 10%;"
                      class="text-center">{{ 'SecondEmployeeName' | translate }}</th>
                    <th style="width: 25%;" class="text-center">{{ 'ItemDate' | translate }}</th>
                    <th style="width: 20%;" class="text-center">{{ 'TotalPrice' | translate }}</th>
                  </tr>
                </thead>
                <tbody *ngFor="let item of clientLastVisitInfo.Items; let i=index">
                  <tr>
                    <td style="width: 5%;" class="text-center">
                      {{ i+1 }}
                    </td>
                    <td style="width: 20%;" class="text-center">
                      {{ item.ItemName }}
                    </td>
                    <td style="width: 20%;" class="text-center">
                      {{ item.EmployeeName }}
                    </td>
                    <td *ngIf="isContainsSecondEmployee(clientLastVisitInfo.Items)" style="width: 20%;"
                      class="text-center">
                      {{ item.SecondEmployeeName ? item.SecondEmployeeName : ('NotFound' | translate) }}
                    </td>
                    <td style="width: 25%;" class="text-center">
                      {{ item.ItemDate | date: 'yyyy-MM-dd hh:mm a' }}
                    </td>

                    <td style="width: 20%;" class="text-center">
                      {{ item.TotalPrice.toFixed(sharedService.GetFractionRoundCount)}}
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <div class="col-lg-12" *ngIf="!clientLastVisitInfo">
        <div class="col-md-12 text-center py-4 my-4">
          <i class="fas fa-circle-notch fa-spin fa-3x"></i>
          <h1>{{'Loading' | translate}} </h1>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="activeModal.close('Close click')">
      {{'Close' | translate}}</button>
    <button type="button" class="btn btn-danger" (click)="printPage()">{{'Print' |
      translate}}</button>
  </div>
</div>
